// 组件对象，大写
import setDefaultRadio from './setDefaultRadio.vue'
export default setDefaultRadio
